const styles = theme => ({
  header: {
    width:'100%',
    height:72,
    paddingLeft:2,
    paddingReft:2,
    paddingTop:48,
    alignItems:'center',
    position:'fixed',
    fontSize: 17,
    marginLeft: 43,
    display:'none',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 43,
      display:'none',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
      display:'inline',
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/ApplicationBar/components/ToolBar/components/Title/styles.js